// Whether a failed session check means the session is really gone.
//
// AuthContext used to clear the token on ANY error from /api/auth/me. A backend
// restart (every deploy answers 502 for a few seconds), a timeout on the slow
// network path or a 429 therefore logged the user out and dropped whatever they
// were typing. Seen live on 2026-09-14: a page reload during a deploy landed a
// logged-in client on /login.
//
// Only an answer from the server that the credentials are not valid (401), the
// account is not allowed (403) or no longer exists (404) ends the session.
// Network errors, timeouts, 429 and 5xx keep it: the next request retries.
export const SESSION_ENDING_STATUSES = Object.freeze([401, 403, 404]);

export const shouldEndSessionOnAuthError = (error) => {
  const status = error?.response?.status;
  return SESSION_ENDING_STATUSES.includes(status);
};
